<template>
    <div class="not-found">
        <img src="../images/404.png" alt="">
        <p>我勒个去，页面被外星人挟持了!去<span class="primary cursor" @click="toLogin">首页</span>吧</p>
    </div>
</template>
<script>
    export default {
        data() {

        },
        computed: {

        },
        methods: {
            toLogin() {
                this.$router.push({path: '/passport/login'});
                location.reload();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// 404.vue?048eba2b